// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2rh6g","errorLogs":"styles_errorLogs__DgBX0"};